
// @group components

export default {
  name: 'NextServiceComponent',
  props: ['data']
}
